import watchApproveAgentSourcedCreator from './approveCreator'
import watchBulkRejectAgentSourcedCreators from './bulkRejectCreators'
import watchDownloadShortlistCsv from './downloadShortlistCsv'
import watchFetchAgentSourcedCreatorsCount from './fetchCounts'
import watchFetchAgentSourcedCreators from './fetchCreators'
import watchFetchAgentSourcedCreatorsByToken from './fetchCreatorsByToken'
import watchRejectAgentSourcedCreator from './rejectCreator'
import watchShortlistAgentSourcedCreator from './shortlistCreator'
import watchUndoAgentSourcedCreatorAction from './undoCreatorAction'
import watchUnshortlistAgentSourcedCreator from './unshortlistCreator'

export const agentSourcedCreatorsSagas = [
  watchFetchAgentSourcedCreators,
  watchFetchAgentSourcedCreatorsCount,
  watchFetchAgentSourcedCreatorsByToken,
  watchApproveAgentSourcedCreator,
  watchRejectAgentSourcedCreator,
  watchBulkRejectAgentSourcedCreators,
  watchUndoAgentSourcedCreatorAction,
  watchShortlistAgentSourcedCreator,
  watchUnshortlistAgentSourcedCreator,
  watchDownloadShortlistCsv,
]
